import { REDUCER_NAME } from './sportsbook-constants';
import createSliceSelector from '../../../utils/create-slice-selector';
import { State } from './sportsbook-duck';

const selectSportsbookState = createSliceSelector<State>(REDUCER_NAME);
export default selectSportsbookState;
